module.exports = __webpack_public_path__ + "static/media/i-6mXxTf7-XL.9b7cda9e.jpg";